import { RGB } from './types';

const convertHexColorToRGB = (hexString: string): RGB => {
  // chop off the preceding # if it exists
  const string = hexString.replace(/#/g, '');
  const rChars = string.slice(0, 2);
  const gChars = string.slice(2, 4);
  const bChars = string.slice(4);
  const r = parseInt(rChars, 16);
  const g = parseInt(gChars, 16);
  const b = parseInt(bChars, 16);
  return {
    r,
    g,
    b,
  };
}; // defined according to this reference:
// https://www.w3.org/TR/WCAG20/#relativeluminancedef

export default convertHexColorToRGB;
